import { render, staticRenderFns } from "./ConfigurazioneContabilitaCausaleDocumentoEditModalComponent.vue?vue&type=template&id=241cfcac&scoped=true"
import script from "./ConfigurazioneContabilitaCausaleDocumentoEditModalComponent.vue?vue&type=script&lang=js"
export * from "./ConfigurazioneContabilitaCausaleDocumentoEditModalComponent.vue?vue&type=script&lang=js"
import style0 from "./ConfigurazioneContabilitaCausaleDocumentoEditModalComponent.vue?vue&type=style&index=0&id=241cfcac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "241cfcac",
  null
  
)

export default component.exports